import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { useAuthContext } from '@myphx-engineering/auth/client';
import {
    Anchor,
    FullBleed,
    Image,
    Stack,
} from '@myphx-engineering/phx-design-system';

import { useAppMaintenanceStatus } from '../../../hooks/use-app-maintenance-status';
import { ConditionalComponent } from '../../utility/ConditionalComponent';

export const UnauthHomeFooter = () => {
    const { t } = useTranslation();
    const { disableAuthFlows, signIn, signUp } = useAuthContext();
    const location = useLocation();
    const { isMaintenanceActive } = useAppMaintenanceStatus();

    return (
        <FullBleed color="primary" bold>
            <Stack px="sm" py="xxl" gap="sm">
                <Image w="144px" src="/static/img/lilly-logo-neg.png" />
                <ConditionalComponent condition={!isMaintenanceActive}>
                    <Stack gap="xs" align="start">
                        <Anchor
                            onClick={() => signIn()}
                            disabled={disableAuthFlows}
                            color="white"
                            textDecoration="none"
                        >
                            {t('unauth.footer.signIn')}
                        </Anchor>
                        <Anchor
                            onClick={() => signUp(location.pathname)}
                            disabled={disableAuthFlows}
                            color="white"
                            textDecoration="none"
                        >
                            {t('unauth.footer.createAccount')}
                        </Anchor>
                    </Stack>
                </ConditionalComponent>
            </Stack>
        </FullBleed>
    );
};
